<template>
  <v-container
    fluid
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="10"
      >
        <v-form ref="form">
          <base-material-card
            color="green"
            :title="title"
          >
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="customer.name"
                    :label="$t('Components.Forms.Customer.Labels.Name')"
                    :rules="[nameValidation]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="customer.vatNumber"
                    class="purple-input"
                    :label="$t('Components.Forms.Customer.Labels.Vat')"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="customer.address"
                    :label="$t('Components.Forms.Customer.Labels.Address')"
                    class="purple-input"
                    :rules="[addressValidation]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="customer.postalCode"
                    :label="$t('Components.Forms.Customer.Labels.Zip')"
                    class="purple-input"
                    :rules="[zipValidation]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="customer.city"
                    :label="$t('Components.Forms.Customer.Labels.City')"
                    class="purple-input"
                    :rules="[cityValidation]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-autocomplete
                    v-model="customer.country"
                    color="primary"
                    item-color="primary"
                    :label="$t('Components.Forms.Customer.Labels.Country')"
                    :items="countries"
                    item-text="name"
                    item-value="isoCode"
                    :rules="[countryValidation]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="customer.contactName"
                    :label="$t('Components.Forms.Customer.Labels.ContactName')"
                    class="purple-input"
                    :rules="[contactNameValidation]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="customer.contactEmail"
                    :label="$t('Components.Forms.Customer.Labels.ContactEmail')"
                    class="purple-input"
                    :rules="[contactEmailValidation]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="customer.contactPhone"
                    :label="$t('Components.Forms.Customer.Labels.ContactPhone')"
                    class="purple-input"
                    :rules="[contactPhoneValidation]"
                  />
                </v-col>
              </v-row>
            </v-container>
            <template v-slot:actions>
              <v-row
                no-gutters
                align="center"
              >
                <v-col
                  cols="auto"
                  class="mr-auto"
                >
                  <v-icon class="mr-1">
                    mdi-menu-left
                  </v-icon>
                  <router-link
                    :to="{ name: 'Customers', }"
                  >
                    <span>{{ $t('Components.Forms.Customer.Links.All') }}</span>
                  </router-link>
                </v-col>
                <v-col cols="auto">
                  <debounce-v-btn
                    class="font-weight-light"
                    color="success"
                    loading:loading.commit
                    @click="Commit"
                  >
                    {{ $t('General.Buttons.Save') }}
                  </debounce-v-btn>
                  <debounce-v-btn
                    class="font-weight-light"
                    color="success"
                    loading:loading.commit
                    @click="CommitAndClose"
                  >
                    {{ $t('General.Buttons.SaveClose') }}
                  </debounce-v-btn>
                  <v-btn
                    class="font-weight-light v-btn--tight"
                    color="warning"
                    loading:loading.commit
                    @click="Close"
                  >
                    {{ $t('General.Buttons.DiscardChanges') }}
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </base-material-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import validation from '@/helpers/validationHelper'

  export default {
    props: {
      uid: {
        type: String,
        required: false,
        default: null,
      },
    },
    data: () => ({
      customer: {
        uid: '',
        name: '',
        vatNumber: '',
        address: '',
        zip: '',
        city: '',
        country: '',
        contactName: '',
        contactEmail: '',
        contactPhone: '',
      },
      loading: {
        commit: false,
      },
      badRequestReasons: {},
    }),
    computed: {
      title () {
        if (!this.customer.uid) {
          return this.$t('Components.Forms.Customer.Titles.Create')
        }
        return this.$t('Components.Forms.Customer.Titles.Edit')
      },
      customers () {
        return this.$store.state.customers.data
      },
      parsedDirection () {
        return this.direction.split(' ')
      },
      countries () {
        return this.$store.state.general.countries
      },
    },
    created: async function () {
      if (!this.uid) {
        if (this.$store.state.general.countries.length < 1) {
          await this.$store.dispatch('RefreshCountries')
        }
        return
      }
      var existingCustomer = this.customers.find(
        element => element.uid === this.uid
      )

      if (!existingCustomer) {
        // refresh the customers, might be first page load, might be some data missing
        await this.$store.dispatch('RefreshCustomers')
        existingCustomer = this.customers.find(
          element => element.uid === this.uid
        )
        if (!existingCustomer) {
          return
        // todo show error
        }
      }
      this.updateLocalCustomer(existingCustomer)
    },
    methods: {
      async Commit () {
        this.badRequestReasons = {}
        if (this.$refs.form.validate() !== true) {
          return false
        }
        this.loading.commit = true
        var storeChange
        if (!this.customer.uid) {
          storeChange = await this.$store.dispatch('CreateCustomer', this.customer)
        } else {
          storeChange = await this.$store.dispatch('UpdateCustomer', this.customer)
        }
        if (storeChange.success) {
          this.updateLocalCustomer(storeChange.value)
        } else {
          this.badRequestReasons = storeChange.badRequestReasons.errors
          // trigger the rules so the api errors are shown
          this.$refs.form.validate()
        }
        this.loading.commit = false
      },
      async CommitAndClose () {
        await this.Commit()
        this.Close()
      },
      Close () {
        this.$router.go(-1)
      },
      updateLocalCustomer (data) {
        this.customer.uid = data.uid
        this.customer.name = data.name
        this.customer.vatNumber = data.vatNumber
        this.customer.address = data.address
        this.customer.postalCode = data.postalCode
        this.customer.city = data.city
        this.customer.country = data.country
        this.customer.contactName = data.contactName
        this.customer.contactEmail = data.contactEmail
        this.customer.contactPhone = data.contactPhone
      },
      nameValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Customer.Validation.RequiredName')
      },
      addressValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Customer.Validation.RequiredAddress')
      },
      cityValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Customer.Validation.RequiredCity')
      },
      zipValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Customer.Validation.RequiredZip')
      },
      countryValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Customer.Validation.RequiredCountry')
      },
      contactNameValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Customer.Validation.RequiredContactName')
      },
      contactEmailValidation (value) {
        if (!validation.stringIsNotNullOrWhitespace(value)) {
          return this.$t('Components.Forms.Customer.Validation.RequiredContactEmail')
        }
        if (!validation.stringIsEmail(value)) {
          return this.$t('Components.Forms.Customer.Validation.InvalidContactEmail')
        }
        if (this.badRequestReasons && this.badRequestReasons.ContactEmail) {
          return this.$t('Components.Forms.Customer.Validation.BadRequestReasons.' + this.badRequestReasons.ContactEmail[0])
        }
        return true
      },
      contactPhoneValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Customer.Validation.RequiredContactPhone')
      },
    },
  }
</script>
